/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasTextCell } from "./CanvasTextCell";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasNumericCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasNumericCell, _super);
    function CanvasNumericCell(a) {
        var _this = _super.call(this, a) || this;
        _this.ce(2);
        _this.cm(1);
        return _this;
    }
    CanvasNumericCell.$t = markType(CanvasNumericCell, 'CanvasNumericCell', CanvasTextCell.$);
    return CanvasNumericCell;
}(CanvasTextCell));
export { CanvasNumericCell };
//# sourceMappingURL=CanvasNumericCell.js.map
